import {
  feature,
  demoFile,
  extendWithVariants,
  variant,
  story,
  INPUT,
  CLICK,
} from 'system/demo';
import { Composer } from 'component/comment';

const serverCall = {
  eventlog: { logEvent: async () => {} },
  moderation: {
    moderateComment: async () => ({ violates: false }),
  },
  blocklist: {
    checkBlocklist: async ({ text }: { text: string }) =>
      text.includes('cat') ? { violates: true } : { violates: false },
  },
};

const globals = {
  name: 'blocklist demo: The word "cat" is not allowed here.',
  questionAuthor: 'a',
  questionTime: Date.now(),
};

demoFile('open-modules/zdf/feature/premoderation/blocklist');

feature('blocklist', {
  structureKey: 'question',
  features: { premoderation: true },
  state: { globals, serverCall },
});

extendWithVariants(
  'Composer',
  'Blocklist',
  Composer,
  {
    args: { commentKey: 'new' },
    structureKey: 'question',
    features: ['premoderation', 'blocklist'],
    state: { globals, serverCall },
  },
  [
    variant('Blocklisted term', {}, [
      story('Blocklist hit', [INPUT('comment-edit', 'I love cats'), CLICK('Post')]),
    ]),
    variant('Clean text', {}, [
      story('No violation', [INPUT('comment-edit', 'Hello world'), CLICK('Post')]),
    ]),
  ]
);
